var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M11.903 2.01a.47.47 0 0 0-.298.206l-.065.096-.006 4.608-.006 4.608H2.375l-.12.063a.465.465 0 0 0-.039.807l.098.066 4.607.006 4.607.006.006 4.607.006 4.608.066.097a.46.46 0 0 0 .398.212.43.43 0 0 0 .409-.25l.063-.12v-9.154l4.608-.006 4.607-.006.097-.066A.46.46 0 0 0 22 12a.43.43 0 0 0-.25-.41l-.12-.062h-9.154l-.006-4.599-.005-4.598-.068-.11a.47.47 0 0 0-.494-.21",
    clipRule: "evenodd"
  })));
};
export default SvgPlus;